import genericStyles from "../../Styles/genericStyles.module.css";
import { useState, createContext } from "react";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { ETableEditAction, EWidths } from "../../Utils/Enums";
import GenericModal from "../GenericModal";
import { FormsIds } from "../../Utils/Constants";
import Predefined from "./Predefined";
import { Button } from "@mui/material";
import { endpoints } from "../../Utils/UrlEnum";
import { TagModel } from "../../Utils/Models";

export const CRUDContext = createContext(new TagModel());

export default function PredefinedTable() {
  const [open, setOpen] = useState(false);
  const [triggerReload, setTriggerReload] = useState(false);
  const [contextValue, setContextValue] = useState(new TagModel());

  const clientsColumns = [
    {
      label: `${Vocabulary?.name}`,
      name: "name",
      options: {
        sort: false,
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          title="Predefinite"
          columns={clientsColumns}
          onEditAction={ETableEditAction.MODAL}
          handleModalForm={setOpen}
          CRUDEndPoint={endpoints.predefined}
          addOrEditForm={
            <GenericModal
              onClose={() => {
                setOpen(false);
                setTriggerReload(false);
                setContextValue(new TagModel());
              }}
              maxWidth={EWidths.MD}
              open={open}
              actions={
                <div className={genericStyles.modalActions}>
                  <Button
                    color="secondary"
                    onClick={() => {
                      setOpen(false);
                      setTriggerReload(false);
                    }}
                    variant="outlined"
                    fullWidth
                  >
                    {Vocabulary.cancel}
                  </Button>
                  <Button
                    fullWidth
                    type="submit"
                    form={FormsIds.tagForm}
                    variant="contained"
                  >
                    {Vocabulary.save}
                  </Button>
                </div>
              }
              title={Vocabulary.editModalTitle}
            >
              <Predefined
                setOpen={setOpen}
                setTriggerReload={setTriggerReload}
              />
            </GenericModal>
          }
          triggerReload={triggerReload}
          setContextValue={setContextValue}
        ></MUIDataTableCustomStyle>
      </CRUDContext.Provider>
    </div>
  );
}
